import HighlightOff from '@mui/icons-material/HighlightOff';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import LoadingAlert from '../../@iosper/components/LoadingButton/LoadingAlert';
import { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import backgroundQrFramework from '../../assets/images/svg/qr-framework.svg';

const OrdenDigitalQRMessageEvent = ({
  message = '',
  qrValue = null,
  prestador = {},
  status,
  open,
  onHandleCerrar = null,
}) => {
  const handleClose = () => {
    if (onHandleCerrar) {
      onHandleCerrar();
    }
  };

  useEffect(() => {}, [message]);

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={(e) => handleClose(e)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent sx={{ py: 4, px: 4, minHeight: '400px' }}>
          <Stack direction='column' spacing={4} justifyContent='center' alignItems='center' sx={{ height: '100%' }}>
            {prestador?.nombre && (
              <Box sx={{ textAlign: 'center', width: '100%' }}>
                <Typography variant='h6' gutterBottom sx={{ mb: 1 }}>
                  Prestador
                </Typography>
                <Typography variant='subtitle1' sx={{ fontSize: '1.1rem' }}>
                  {prestador?.nombre} ({prestador?.matricula})
                </Typography>
              </Box>
            )}

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '150px',
                width: '100%',
              }}
            >
              <LoadingAlert result={status} defaultLoading loadingTime={1000} />
              {qrValue && (
                <Box
                  sx={{
                    backgroundImage: `url("${backgroundQrFramework}")`,
                    width: '170px',
                    height: '170px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: '0.08',
                    pointerEvents: 'none',
                    mt: 2,
                  }}
                >
                  <QRCodeSVG value={JSON.stringify({ token: qrValue })} />
                </Box>
              )}
            </Box>

            <Box sx={{ textAlign: 'center', width: '100%' }}>
              <Typography variant='subtitle2' sx={{ fontSize: '1rem', lineHeight: 1.6 }}>
                {message}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, justifyContent: 'center' }}>
          <Button
            size='large'
            startIcon={<HighlightOff />}
            variant='contained'
            color='neutral'
            sx={{ minWidth: '200px' }}
            onClick={(e) => handleClose(e)}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default OrdenDigitalQRMessageEvent;
